import React, { Fragment } from "react";
import { InputField, RadioField, getPropsFromData } from "../../FormField";

export const createRadioFields = (data, fieldName) => (
  <Fragment>
    <td>
      <RadioField radioValue="Yes" {...getPropsFromData(data, fieldName)} />
    </td>
    <td />
    <td>
      <RadioField radioValue="No" {...getPropsFromData(data, fieldName)} />
    </td>
  </Fragment>
);

export const createInputFields = (data, fieldName) => (
  <td colSpan="3">
    <InputField fullDisplay={true} {...getPropsFromData(data, fieldName)} />
  </td>
);



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/common/utils.jsx